var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41016 12.8899H10.2366L10.5036 15.12C10.5036 15.12 8.96555 14.581 8.41016 12.8899Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2011 12.8694H21.3747L21.1077 15.0995C21.1077 15.0995 22.6457 14.5605 23.2011 12.8694Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8757 11.8331H21.5153L21.7609 9.79329L21.2269 9.20142H10.4073L9.8733 9.79329L10.119 11.8437H7.73716L7.20312 12.4356C7.21381 12.5624 7.59831 15.4372 10.653 16.3039L10.7064 16.7161L10.9307 17.086L14.8612 19.7812H16.741L20.6929 17.086L20.9172 16.7161L20.9706 16.2933C24.0146 15.4161 24.3884 12.5518 24.4097 12.425L23.8757 11.8331ZM8.41005 12.8901H10.2364V12.8478L10.5035 15.1202C9.20042 14.5811 8.63434 13.5453 8.41005 12.8901ZM19.8811 16.3462L15.7904 19.1364L11.7211 16.3462L11.0055 10.2583H20.6288L19.8811 16.3462ZM21.1094 15.1202L21.3764 12.8901H23.1815C22.9572 13.5453 22.3911 14.5811 21.0987 15.1202H21.1094Z",
    fill: "#4611A7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7815 23.3325H16.3463V19.7812H15.2782V23.3325H12.7148L12.1915 23.7341L11.6788 25.7423L12.2022 26.3976H19.2942L19.8068 25.7423L19.2835 23.7341L18.7708 23.3325H18.7815ZM12.8857 25.3406L13.1314 24.3894H18.3649L18.6106 25.3406H12.8964H12.8857Z",
    fill: "#4611A7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0049 10.2581L11.7312 16.3565L15.8005 19.1362L19.8912 16.3459L20.6282 10.2581H11.0049Z",
    fill: "#4611A7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1383 24.3899H18.3718L18.5961 25.3623H12.882L13.1383 24.3899Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1006 16.9487C17.813 16.9487 19.2012 15.617 19.2012 13.9743C19.2012 12.3317 17.813 11 16.1006 11C14.3882 11 13 12.3317 13 13.9743C13 15.617 14.3882 16.9487 16.1006 16.9487ZM14.8611 14.1888L15.8511 15.7584H16.8301L15.7521 14.2338C16.0234 14.1838 16.2453 14.0905 16.4176 13.9538C16.5899 13.8139 16.6944 13.6206 16.7311 13.374H17.3416V13.0041H16.7201C16.6871 12.8341 16.6064 12.6858 16.4781 12.5592H17.3416V12.1892H14.8611V12.5592H15.2956C15.4789 12.5592 15.6219 12.6025 15.7246 12.6891C15.8273 12.7724 15.8951 12.8774 15.9281 13.0041H14.8611V13.374H15.9336C15.8969 13.5139 15.8126 13.6239 15.6806 13.7039C15.5486 13.7805 15.3854 13.8189 15.1911 13.8189H14.8611V14.1888Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyIcon);
export default __webpack_public_path__ + "static/media/trophy-icon.f1eb1363e180b9875fe327345b9e0402.svg";
export { ForwardRef as ReactComponent };